import React, { useEffect, useState } from 'react'
import { Add_CustomType_Api, GetAll_Active_CustomType_Api } from '../../API/CustomTypeApi';
import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
// ======================================================================

export const CustomTypeCombo = ({
    setLoading,
    showMessage,
    parentId,
    placeHolder,
    onChange,
    value
}) => {
    // ======================================================================
    const [customTypes, setCustomTypes] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [parentId]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Active_CustomType_Api({ parentId: parentId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setCustomTypes(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            // showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        if(onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
        value={value}
            placeholder={placeHolder}
             onChange={handleChange}
            optionFilterProp="children"
            showSearch
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            {customTypes.map((customType, key) => (
                <Option key={key} value={customType.id}>
                    {customType.title}
                </Option>
            ))}
        </Select>
    )
}
